module.exports = __webpack_public_path__ + "static/media/selfCertifyYourself.8cec31be.svg";